import React from 'react'
import useScript from './useScript'

/**
 * Hook for adding Gigya as a dependency for a component.
 * @returns [boolean] gigyaHasLoaded
 */
export function useGigya () {
  return useScript({
    src: `https://cdns.gigya.com/js/gigya.js?apiKey=${window.marketplace.state.app.gigya.api_key}`,
    text: JSON.stringify(window.marketplace.state.app.gigya.modal_settings)
  })
}

/**
 * Wrapper for class components that can't use the useGigya hook. Component
 * will not render until Gigya has loaded.
 */
export function withGigya (Component) {
  return function ComponentWithGigya (props) {
    const [gigyaHasLoaded] = useGigya()

    return gigyaHasLoaded && <Component {...props} />
  }
}
